<template>
	<v-app>
		<div @mouseover="showDrawer" @mouseleave="hideDrawer">
			<v-navigation-drawer v-model="drawer" app floating :width="navbar" class="nav-shadow" :class="{'nav--isCollapsed': (navbar === 70)}">
				<v-list style="background: rgba(0,0,0,0.2); margin-bottom: 1rem;">
					<v-list-item class="v-list-item-logo" active-class="opacity-1" @click="goDashboard()">
						<v-list-item-action class="v-app-logo" style="opacity: 1;filter: brightness(0) invert(1);">
							<img width="100%" class="mx-auto maxicon" :src="require('/public/img/ic-logo.png')">
							<img width="100%" class="minicon" :src="require('/public/img/ic-logo-min.png')">
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								<div class="pt-1 cl-white font-size-10 font-weight-500 text-capitalize">
									Virtual Office
								</div>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>

				<v-list dense class="pt-0 cus-m-navbar">
					<template v-for="(menu, idm) in arrMenu">
						<div class="cuspad-list-item" v-if="menu.children.length == 0" :key="idm">
							<v-list-item link router :to="`${menu.path}`" color="cl-primary-light" class="no-drop" @click="setActiveMenu()">
								<v-list-item-action>
									<v-icon>{{ menu.icon }}</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>
										<div class="d-flex align-center justify-space-between">
											{{ menu.title }} 
										</div>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
						<div class="cuspad-list-item" v-else :key="idm">
							<v-list-group 
								:prepend-icon="menu.icon" 
								no-action 
								color="cl-primary-light" 
								class="v-list-group__items expand-transition-leave-active expand-transition-leave-to"
								:class="(activeMenu === menu.title) ? 'is-activemenu' : ''">
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title :class="(activeMenu === menu.title) ? 'cl-white font-weight-bold' : ''">{{ menu.title }}</v-list-item-title>
									</v-list-item-content>
								</template>
								<template v-for="(sub, ids) in menu.children">
									<div class="cuspad-list-item" :key="ids">
										<v-list-item router :to="`${sub.path}`" @click="setActiveMenu(sub.path)" color="cl-primary-light" class="no-drop" :key="ids">
											<v-list-item-content>
												<v-list-item-title>
													<span v-if="navbar == 70" class="collapse-icon">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
															</template>
															<span class="d-flex align-center justify-space-between">
																{{ sub.title }}
															</span>
														</v-tooltip>
													</span>
													<span v-else>
														<span class="d-flex align-center justify-space-between">
														{{ sub.title }}
														</span>
													</span>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</div>
								</template>
							</v-list-group>
						</div>
					</template>
				</v-list>
			</v-navigation-drawer>
		</div>

		<Header :isDrawer="navbar" v-on:childToParent="clickDrawer" />

		<v-main class="">
			<v-container fluid class="px-3">
				<v-row align="center" justify="center">
					<v-col class="px-0 px-md-3">
						<v-snackbar v-model="snackbar.show" timeout="4000" right top :color="snackbar.color">
							{{snackbar.text}}
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<v-snackbar v-model="errorAlert.show" timeout="4000" right top :color="errorAlert.color" class="mt-5">
							<div v-for="(alert, i) in errorAlert.alert" :key="i">{{ alert }}</div>
							<template v-slot:action="{ attrs }">
								<v-btn color="white" text v-bind="attrs" @click="hideAlert">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</template>
						</v-snackbar>
						<router-view />
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Header from '@/components/layout/vo-general/Header';

export default {
	components: {
		Header
	},
	props: {
	},
	computed: {
		...mapState(['snackbar', 'errorAlert']),
	},
	data: () => ({
		drawer: null,
		navbar: 236,
		toggleDrawer: false,
		activeMenu: '',
		dashboardPath: '',
		arrMenu: [],
	}),
	methods: {
		...mapMutations(['hideSnackbar', 'hideAlert']),

		goDashboard() {
			this.$router.push({ name: 'dashboard' })
		},
		setActiveMenu(child) {
			if (child) {
				// eslint-disable-next-line no-unused-vars
				this.arrMenu.forEach((menu, index) => {
					if (menu.children.length > 0) {
						// eslint-disable-next-line no-unused-vars
						menu.children.forEach((childMenu, idc) => {
							if (childMenu.path === child) this.activeMenu = menu.title
						})
					}
				})
			} else {
				this.activeMenu = ''
			}
		},
		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 236) {
					this.navbar = 70
				} else {
					this.navbar = 236
				}
			} else {
				this.drawer = !this.drawer
			}
			this.toggleDrawer = false
		},
		showDrawer() {
			if (this.navbar == 70) {
				this.navbar = 236
				this.toggleDrawer = true
			}
		},
		hideDrawer() {
			if (this.toggleDrawer == true) {
				this.navbar = 70
			}
		},
	},
	created() {
		let voMenu = [
			{
				title: 'Dashboard',
				path: '/',
				icon: 'mdi-home-outline',
				children: [],
			}, {
				title: 'My Wallet',
				path: '',
				icon: 'mdi-database-outline',
				children: [
					{
						title: 'Bonus Summary',
						path: '/bonus-summary',
					},
					{
						title: 'Bonus History',
						path: '/bonus-history',
					},
					{
						title: 'Bonus Transfer History',
						path: '/bonus-transfer-history',
					},
				],
			}, {
				title: 'Network',
				path: '',
				icon: 'mdi-account-group-outline',
				children: [
					{
						title: 'New Registration',
						path: '/registration',
					}, {
						title: 'Genealogy',
						path: '/genealogy',
					}, {
						title: 'Sponsor Members',
						path: '/sponsor',
					}, {
						title: 'Network Growth',
						path: '/network-growth',
					}, {
						title: 'Downline Members',
						path: '/downline',
					}
				]
			}, {
				title: 'Product Transactions',
				path: '',
				icon: 'mdi-cart-arrow-down',
				children: [
					{
						title: 'Order Product',
						path: '/order-product',
					},
					{
						title: 'Order History',
						path: '/order-history',
					},
				],
			}, {
				title: 'Repeat Order',
				path: '/',
				icon: 'mdi-credit-card-sync-outline',
				children: [
					{
						title: 'Add RO',
						path: '/add-ro',
					},
					{
						title: 'RO History',
						path: '/ro-history',
					},
				],
			}, {
				title: 'Product',
				path: '',
				icon: 'mdi-package-variant-closed',
				children: [
					{
						title: 'Product List',
						path: '/product-list',
					},
				],
			}, {
				title: 'Reward',
				path: '',
				icon: 'mdi-medal',
				children: [
					{
						title: 'Reward List',
						path: '/reward-list',
					},
					{
						title: 'My Rewards',
						path: '/my-reward',
					},
				],
			},
			{
				title: 'Testimonials',
				path: '/testimonials',
				icon: 'mdi-format-float-left',
				children: [],
			},
			{
				title: 'Messages',
				path: '/',
				icon: 'mdi-email',
				children: [
					{
						title: 'Add Message',
						path: '/add-message',
					},
					{
						title: 'Inbox Message',
						path: '/inbox-message',
					},
					{
						title: 'Sent Message',
						path: '/sent-message',
					},
					// {
					// 	title: 'Archive Message',
					// 	path: '/archive-message',
					// },
				],
			},
		]
		voMenu.forEach((el) => {
			this.arrMenu.push(el)
		})
		this.setActiveMenu(this.$route.path)
	}
};
</script>

<style lang="scss" scoped>
	.cus-m-navbar {
		padding: 0 5px;
	}

	.maxicon {
			display: block;
		}
		.minicon {
			display: none;
			padding: 5px;
			margin-top: -5px;
		}

	.nav--isCollapsed {
		.maxicon {
			display: none;
		}
		.minicon {
			display: block
		}
	}
</style>